// extracted by mini-css-extract-plugin
export default {"container":"ayNWS8","indicatorContainer":"E14TsV","label":"IsbotF","small":"zFTu9r","large":"KQS8dc"};